<template>
    <el-dialog title="添加微信洽谈合作" :visible.sync="dialogVisible" width="25%" center :before-close="handleClose" v-loading="loading">
        <div class="qr-container">
            <div class="qr-left">
                <span class="iconfont icon-weixin" style="color: #549E51;"></span>
                <p class="qr-desc">添加微信洽谈合作</p>
            </div>
            <div class="qr-right">
                <img :src="qrCodeUrl" alt="二维码" class="qr-code" />
            </div>
        </div>

    </el-dialog>
</template>
  
<script>
import { fetchCustomerImg } from '@/api/customer/customerImg';
export default {
    name: 'QrCodeDialog',


    data() {
        return {
            dialogVisible: false,
            qrCodeUrl: '',
            loading: false
        };
    },

    methods: {
        showDialog() {
            this.dialogVisible = true;
            this.getCustomerImg();
        },
        getCustomerImg() {
            this.loading = true;
            fetchCustomerImg().then(res => {
                const imageUrl = window.URL.createObjectURL(res.data);
                this.qrCodeUrl = imageUrl;
            }).finally(() => {
                this.loading = false;
            })
        },
        handleClose() {
            this.dialogVisible = false;
            if (this.qrCodeUrl) {
                window.URL.revokeObjectURL(this.qrCodeUrl);
                this.qrCodeUrl = '';
            }
        }
    }
};
</script>
  
<style scoped>
.qr-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 40px;
}

.qr-left {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.iconfont{
    font-size: 50px;
}
.qr-desc {
    font-size: 14px;
    color: #666;
    min-width: 125px;
}

.qr-right {
   text-align: right;
}

.qr-code {
    width: 70%;
}

.dialog-footer {
    text-align: center;
}
::v-deep .el-dialog--center .el-dialog__body{
    text-align: center;
}
</style>